import React, { useState } from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import { Button } from "@material-ui/core";
import { Pagination } from "react-bootstrap";
import { Dropdown } from "react-bootstrap";
import {
  DropdownCustomToggler,
  DropdownMenu4,
} from "../../_metronic/_partials/dropdowns";
import { Modal } from "react-bootstrap";
import { ProgressBar } from "react-bootstrap";
import { Link } from "react-router-dom";
import { makeStyles, TextField } from "@material-ui/core";

export function PageId57() {
  const [isShow, setIsShow] = useState(false);
  const toggleShow = () => {
    setIsShow(!isShow);
  };

  const useStyles = makeStyles((theme) => ({
    container: {
      display: "flex",
      flexWrap: "wrap",
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 200,
    },
  }));

  const classes = useStyles();
  // The first commit of Material-UI
  const [selectedDate, setSelectedDate] = React.useState(
    new Date("2014-08-18T21:11:54")
  );

  return (
    <div id="pageid57">
      {/* pageId58 modal 구매이력 시작 */}
      {/* <Modal
        show={isShow}
        onHide={toggleShow}
        className="big-modal"
        // aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">구매이력</Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-5">
          <div className="gutter-b d-flex justify-content-between align-items-center">
            <div className="input-icon h-40px">
              <input
                type="text"
                className="form-control form-control-lg form-control-solid h-40px bg-white"
                placeholder="검색"
                id="generalSearch"
                autoComplete="false"
              />
              <span>
                <span className="svg-icon svg-icon-lg">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")}
                  />
                </span>
              </span>
            </div>
            <p className="mb-0">5bot for 30days(100,000원)</p>
          </div>
          <table
            className="table table-head-custom table-vertical-center bg-white w-100"
            id="kt_advance_table_widget_1"
          >
            <thead>
              <tr className="text-left">
                <th style={{ minWidth: "100px" }}>고객사명</th>
                <th style={{ minWidth: "100px" }}>ID</th>
                <th style={{ minWidth: "200px" }}>라이선스 키</th>
                <th style={{ minWidth: "150px" }}>구매일시</th>
                <th style={{ minWidth: "150px" }}>사용기간</th>
                <th style={{ minWidth: "100px" }}>Bot 확인</th>
                <th style={{ minWidth: "150px" }}>라이선스 상태</th>
              </tr>
            </thead>
          </table>
          <div className="scroll-table">
            <table className="w-100">
              <tbody>
                <tr>
                  <td>Laidback</td>
                  <td>userAdmin</td>
                  <td>B234B-EXGWX-Y239B-123AB-TBGEQ</td>
                  <td>2021-05-13 16:50:20</td>
                  <td>2021-05-13 - 2021-06-13</td>
                  <td>
                    <Link className="font-weight-bold">3Bot / 5Bot</Link>
                  </td>
                  <td>
                    <span className="label label-l label-inline label-light-success">
                      사용
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>Laidback</td>
                  <td>userAdmin2</td>
                  <td>B234B-EXGWX-Y239B-123AB-TBGEQ</td>
                  <td>2021-05-13 16:50:20</td>
                  <td>2021-05-13 - 2021-06-13</td>
                  <td>
                    <Link className="font-weight-bold">3Bot / 5Bot</Link>
                  </td>
                  <td>
                    <span className="label label-l label-inline label-light-success">
                      사용
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>Laidback</td>
                  <td>userAdmin3</td>
                  <td>B234B-EXGWX-Y239B-123AB-TBGEQ</td>
                  <td>2021-05-13 16:50:20</td>
                  <td>2021-05-13 - 2021-06-13</td>
                  <td>
                    <Link className="font-weight-bold">3Bot / 5Bot</Link>
                  </td>
                  <td>
                    <span className="label label-l label-inline label-light-dark">
                      기간만료
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>Laidback</td>
                  <td>userAdmin</td>
                  <td>B234B-EXGWX-Y239B-123AB-TBGEQ</td>
                  <td>2021-05-13 16:50:20</td>
                  <td>2021-05-13 - 2021-06-13</td>
                  <td>
                    <Link className="font-weight-bold">3Bot / 5Bot</Link>
                  </td>
                  <td>
                    <span className="label label-l label-inline label-light-success">
                      사용
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>Laidback</td>
                  <td>userAdmin</td>
                  <td>B234B-EXGWX-Y239B-123AB-TBGEQ</td>
                  <td>2021-05-13 16:50:20</td>
                  <td>2021-05-13 - 2021-06-13</td>
                  <td>
                    <Link className="font-weight-bold">3Bot / 5Bot</Link>
                  </td>
                  <td>
                    <span className="label label-l label-inline label-light-success">
                      사용
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>Laidback</td>
                  <td>userAdmin</td>
                  <td>B234B-EXGWX-Y239B-123AB-TBGEQ</td>
                  <td>2021-05-13 16:50:20</td>
                  <td>2021-05-13 - 2021-06-13</td>
                  <td>
                    <Link className="font-weight-bold">3Bot / 5Bot</Link>
                  </td>
                  <td>
                    <span className="label label-l label-inline label-light-success">
                      사용
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              // onClick={deleteProducts}
              className="btn btn-primary btn-elevate"
            >
              확인
            </button>
          </div>
        </Modal.Footer>
      </Modal> */}
      {/* pageId58 modal 구매이력 끝 */}

      {/* pageId58 modal Bot 확인 시작 */}
      {/* <Modal
        show={isShow}
        onHide={toggleShow}
        // aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">Bot 확인</Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-5">
          <div className="top-row gutter-b d-flex justify-content-between align-items-center">
            <p className="mb-0">
              B234B-EXGWX-Y239B-123AB-TBGEQ (5bot for 60days)
            </p>
            <p className="mb-0">2Bot / 5Bot</p>
          </div>
          <table
            className="table table-head-custom table-vertical-center bg-white"
            id="kt_advance_table_widget_1"
          >
            <thead>
              <tr className="text-left">
                <th style={{ minWidth: "100px" }}>Bot ID</th>
                <th style={{ minWidth: "100px" }}>Bot 상태</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Logan1</td>
                <td>
                  <span className="label label-l label-inline label-light-success">
                    사용
                  </span>
                </td>
              </tr>
              <tr>
                <td>Logan1</td>
                <td>
                  <span className="label label-l label-inline label-light-dark">
                    기간만료
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              // onClick={deleteProducts}
              className="btn btn-primary btn-elevate"
            >
              확인
            </button>
          </div>
        </Modal.Footer>
      </Modal> */}
      {/* pageId58 modal Bot 확인 끝 */}
      {/* pageId59 라이선스 추가 시작 */}
      {/* <Modal
        show={isShow}
        onHide={toggleShow}
        // aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            라이선스 추가
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Bot 수</p>
          <div className="form-group fv-plugins-icon-container">
            <input
              placeholder="Bot 수"
              type="text"
              className={`form-control form-control-solid h-auto py-5 px-6 `}
              name="text"
            />
          </div>
          <p>사용기간(일)</p>
          <div className="form-group fv-plugins-icon-container">
            <input
              placeholder="사용기간(일)"
              type="text"
              className={`form-control form-control-solid h-auto py-5 px-6 `}
              name="text"
            />
          </div>
          <p>금액(원)</p>
          <div className="form-group fv-plugins-icon-container">
            <input
              placeholder="금액(원)"
              type="number"
              className={`form-control form-control-solid h-auto py-5 px-6 `}
              name="number"
            />
          </div>
          <p>상태</p>
          <div className="form-group fv-plugins-icon-container">
            <select
              className="form-control form-control-lg form-control-solid"
              name="language"
            >
              <option>사용</option>
              <option>사용</option>
              <option>사용</option>
            </select>
          </div>
          <p>메모</p>
          <div className="form-group fv-plugins-icon-container">
            <textarea className="modal-textarea"></textarea>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              onClick={toggleShow}
              className="btn btn-light btn-elevate"
            >
              취소
            </button>
            <> </>
            <button
              type="button"
              // onClick={deleteProducts}
              className="btn btn-primary btn-elevate"
            >
              확인
            </button>
          </div>
        </Modal.Footer>
      </Modal> */}
      {/* pageId59 라이선스 추가 끝 */}
      {/* D2: 특정항목을 작성하지 않았을 시 끝 */}
      <Modal
        show={isShow}
        onHide={toggleShow}
        // aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            라이선스 추가 오류
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <h1 className="text-primary mb-5">X</h1>
          <span>xxx항목을 작성해 주세요.</span>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              // onClick={deleteProducts}
              className="btn btn-primary btn-elevate"
            >
              확인
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      {/* D2: 특정항목을 작성하지 않았을 시 끝 */}
      <div className="top-row gutter-b d-flex align-items-center flex-column">
        <div className="input-icon h-40px">
          <input
            type="text"
            className="form-control form-control-lg form-control-solid h-40px bg-white"
            placeholder="검색"
            id="generalSearch"
            autoComplete="false"
          />
          <span>
            <span className="svg-icon svg-icon-lg">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/Search.svg")} />
            </span>
          </span>
        </div>
        <div className="d-flex align-items-center justify-content-end w-100">
          <div className="mr-5 after">
            <Button
              className={`btn btn-light-dark font-weight-bold text-white mr-2`}
            >
              사용
            </Button>
            <Button
              className={`btn font-weight-bold text-light-dark`}
              style={{ border: "solid 1px #D1D3E0" }}
            >
              사용중지
            </Button>
          </div>
          <div>
            <Button
              className={`btn btn-light-dark font-weight-bold text-white mr-2`}
            >
              라이선스 추가
            </Button>
            <Button
              className={`btn font-weight-bold text-light-dark`}
              style={{ border: "solid 1px #D1D3E0" }}
            >
              라이선스 삭제
            </Button>
          </div>
        </div>
      </div>
      <div className="gutter-b">
        <div className="table-responsive">
          <table
            className="table table-head-custom table-vertical-center bg-white"
            id="kt_advance_table_widget_1"
          >
            <thead>
              <tr className="text-left">
                <th style={{ width: "50px" }}>
                  <label className="checkbox checkbox-lg checkbox-single">
                    <input type="checkbox" value="1" />
                    <span></span>
                  </label>
                </th>
                <th style={{ width: "50px" }}>번호</th>
                <th style={{ width: "150px" }}>Bot 수</th>
                <th style={{ width: "150px" }}>사용 기간</th>
                <th style={{ minWidth: "150px" }}>금액</th>
                <th style={{ width: "100px" }}>상태</th>
                <th style={{ minWidth: "200px" }}>등록일시</th>
                <th style={{ width: "150px" }}>구매이력</th>
                <th style={{ width: "100px" }}>작업</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <label className="checkbox checkbox-lg checkbox-single">
                    <input type="checkbox" value="1" />
                    <span></span>
                  </label>
                </td>
                <td>1</td>
                <td>5Bot</td>
                <td>30일</td>
                <td>100,000원</td>
                <td>
                  <span className="label label-xl label-inline label-success">
                    사용
                  </span>
                </td>
                <td>2021-05-13 16:50:20</td>
                <td>
                  <Button
                    className={`btn btn-light-dark font-weight-bold text-white`}
                  >
                    보기
                  </Button>
                </td>
                <td>
                  <div className="card-toolbar">
                    <Dropdown className="dropdown-inline" alignRight>
                      <Dropdown.Toggle
                        className="btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                        variant="transparent"
                        id="dropdown-toggle-top"
                        as={DropdownCustomToggler}
                      >
                        <i className="ki ki-bold-more-hor" />
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                        <ul className="navi">
                          <li className="navi-item" onClick={toggleShow}>
                            수정
                          </li>
                          <li className="navi-item">삭제</li>
                          <li className="navi-item">사용중지</li>
                        </ul>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <label className="checkbox checkbox-lg checkbox-single">
                    <input type="checkbox" value="1" />
                    <span></span>
                  </label>
                </td>
                <td>2</td>
                <td>5Bot</td>
                <td>30일</td>
                <td>100,000원</td>
                <td>
                  <span className="label label-xl label-inline label-primary">
                    사용중지
                  </span>
                </td>
                <td>2021-05-13 16:50:20</td>
                <td>
                  <Button
                    className={`btn btn-light-dark font-weight-bold text-white`}
                  >
                    보기
                  </Button>
                </td>
                <td>
                  <div className="card-toolbar">
                    <Dropdown className="dropdown-inline" alignRight>
                      <Dropdown.Toggle
                        className="btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                        variant="transparent"
                        id="dropdown-toggle-top"
                        as={DropdownCustomToggler}
                      >
                        <i className="ki ki-bold-more-hor" />
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                        <ul className="navi">
                          <li className="navi-item" onClick={toggleShow}>
                            수정
                          </li>
                          <li className="navi-item">삭제</li>
                          <li className="navi-item">사용중지</li>
                        </ul>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <label className="checkbox checkbox-lg checkbox-single">
                    <input type="checkbox" value="1" />
                    <span></span>
                  </label>
                </td>
                <td>3</td>
                <td>5Bot</td>
                <td>30일</td>
                <td>100,000원</td>
                <td>
                  <span className="label label-xl label-inline label-success">
                    사용
                  </span>
                </td>
                <td>2021-05-13 16:50:20</td>
                <td>
                  <Button
                    className={`btn btn-light-dark font-weight-bold text-white`}
                  >
                    보기
                  </Button>
                </td>
                <td>
                  <div className="card-toolbar">
                    <Dropdown className="dropdown-inline" alignRight>
                      <Dropdown.Toggle
                        className="btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                        variant="transparent"
                        id="dropdown-toggle-top"
                        as={DropdownCustomToggler}
                      >
                        <i className="ki ki-bold-more-hor" />
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                        <ul className="navi">
                          <li className="navi-item" onClick={toggleShow}>
                            수정
                          </li>
                          <li className="navi-item">삭제</li>
                          <li className="navi-item">사용중지</li>
                        </ul>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <label className="checkbox checkbox-lg checkbox-single">
                    <input type="checkbox" value="1" />
                    <span></span>
                  </label>
                </td>
                <td>4</td>
                <td>5Bot</td>
                <td>30일</td>
                <td>100,000원</td>
                <td>
                  <span className="label label-xl label-inline label-success">
                    사용
                  </span>
                </td>
                <td>2021-05-13 16:50:20</td>
                <td>
                  <Button
                    className={`btn btn-light-dark font-weight-bold text-white`}
                  >
                    보기
                  </Button>
                </td>
                <td>
                  <div className="card-toolbar">
                    <Dropdown className="dropdown-inline" alignRight>
                      <Dropdown.Toggle
                        className="btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                        variant="transparent"
                        id="dropdown-toggle-top"
                        as={DropdownCustomToggler}
                      >
                        <i className="ki ki-bold-more-hor" />
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                        <ul className="navi">
                          <li className="navi-item" onClick={toggleShow}>
                            수정
                          </li>
                          <li className="navi-item">삭제</li>
                          <li className="navi-item">사용중지</li>
                        </ul>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <label className="checkbox checkbox-lg checkbox-single">
                    <input type="checkbox" value="1" />
                    <span></span>
                  </label>
                </td>
                <td>5</td>
                <td>5Bot</td>
                <td>30일</td>
                <td>100,000원</td>
                <td>
                  <span className="label label-xl label-inline label-success">
                    사용
                  </span>
                </td>
                <td>2021-05-13 16:50:20</td>
                <td>
                  <Button
                    className={`btn btn-light-dark font-weight-bold text-white`}
                  >
                    보기
                  </Button>
                </td>
                <td>
                  <div className="card-toolbar">
                    <Dropdown className="dropdown-inline" alignRight>
                      <Dropdown.Toggle
                        className="btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                        variant="transparent"
                        id="dropdown-toggle-top"
                        as={DropdownCustomToggler}
                      >
                        <i className="ki ki-bold-more-hor" />
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                        <ul className="navi">
                          <li className="navi-item" onClick={toggleShow}>
                            수정
                          </li>
                          <li className="navi-item">삭제</li>
                          <li className="navi-item">사용중지</li>
                        </ul>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <label className="checkbox checkbox-lg checkbox-single">
                    <input type="checkbox" value="1" />
                    <span></span>
                  </label>
                </td>
                <td>6</td>
                <td>5Bot</td>
                <td>30일</td>
                <td>100,000원</td>
                <td>
                  <span className="label label-xl label-inline label-success">
                    사용
                  </span>
                </td>
                <td>2021-05-13 16:50:20</td>
                <td>
                  <Button
                    className={`btn btn-light-dark font-weight-bold text-white`}
                  >
                    보기
                  </Button>
                </td>
                <td>
                  <div className="card-toolbar">
                    <Dropdown className="dropdown-inline" alignRight>
                      <Dropdown.Toggle
                        className="btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                        variant="transparent"
                        id="dropdown-toggle-top"
                        as={DropdownCustomToggler}
                      >
                        <i className="ki ki-bold-more-hor" />
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                        <ul className="navi">
                          <li className="navi-item" onClick={toggleShow}>
                            수정
                          </li>
                          <li className="navi-item">삭제</li>
                          <li className="navi-item">사용중지</li>
                        </ul>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <label className="checkbox checkbox-lg checkbox-single">
                    <input type="checkbox" value="1" />
                    <span></span>
                  </label>
                </td>
                <td>7</td>
                <td>5Bot</td>
                <td>30일</td>
                <td>100,000원</td>
                <td>
                  <span className="label label-xl label-inline label-success">
                    사용
                  </span>
                </td>
                <td>2021-05-13 16:50:20</td>
                <td>
                  <Button
                    className={`btn btn-light-dark font-weight-bold text-white`}
                  >
                    보기
                  </Button>
                </td>
                <td>
                  <div className="card-toolbar">
                    <Dropdown className="dropdown-inline" alignRight>
                      <Dropdown.Toggle
                        className="btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                        variant="transparent"
                        id="dropdown-toggle-top"
                        as={DropdownCustomToggler}
                      >
                        <i className="ki ki-bold-more-hor" />
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                        <ul className="navi">
                          <li className="navi-item" onClick={toggleShow}>
                            수정
                          </li>
                          <li className="navi-item">삭제</li>
                          <li className="navi-item">사용중지</li>
                        </ul>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <label className="checkbox checkbox-lg checkbox-single">
                    <input type="checkbox" value="1" />
                    <span></span>
                  </label>
                </td>
                <td>8</td>
                <td>5Bot</td>
                <td>30일</td>
                <td>100,000원</td>
                <td>
                  <span className="label label-xl label-inline label-success">
                    사용
                  </span>
                </td>
                <td>2021-05-13 16:50:20</td>
                <td>
                  <Button
                    className={`btn btn-light-dark font-weight-bold text-white`}
                  >
                    보기
                  </Button>
                </td>
                <td>
                  <div className="card-toolbar">
                    <Dropdown className="dropdown-inline" alignRight>
                      <Dropdown.Toggle
                        className="btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                        variant="transparent"
                        id="dropdown-toggle-top"
                        as={DropdownCustomToggler}
                      >
                        <i className="ki ki-bold-more-hor" />
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                        <ul className="navi">
                          <li className="navi-item" onClick={toggleShow}>
                            수정
                          </li>
                          <li className="navi-item">삭제</li>
                          <li className="navi-item">사용중지</li>
                        </ul>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <label className="checkbox checkbox-lg checkbox-single">
                    <input type="checkbox" value="1" />
                    <span></span>
                  </label>
                </td>
                <td>9</td>
                <td>5Bot</td>
                <td>30일</td>
                <td>100,000원</td>
                <td>
                  <span className="label label-xl label-inline label-success">
                    사용
                  </span>
                </td>
                <td>2021-05-13 16:50:20</td>
                <td>
                  <Button
                    className={`btn btn-light-dark font-weight-bold text-white`}
                  >
                    보기
                  </Button>
                </td>
                <td>
                  <div className="card-toolbar">
                    <Dropdown className="dropdown-inline" alignRight>
                      <Dropdown.Toggle
                        className="btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                        variant="transparent"
                        id="dropdown-toggle-top"
                        as={DropdownCustomToggler}
                      >
                        <i className="ki ki-bold-more-hor" />
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                        <ul className="navi">
                          <li className="navi-item" onClick={toggleShow}>
                            수정
                          </li>
                          <li className="navi-item">삭제</li>
                          <li className="navi-item">사용중지</li>
                        </ul>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <label className="checkbox checkbox-lg checkbox-single">
                    <input type="checkbox" value="1" />
                    <span></span>
                  </label>
                </td>
                <td>10</td>
                <td>5Bot</td>
                <td>30일</td>
                <td>100,000원</td>
                <td>
                  <span className="label label-xl label-inline label-success">
                    사용
                  </span>
                </td>
                <td>2021-05-13 16:50:20</td>
                <td>
                  <Button
                    className={`btn btn-light-dark font-weight-bold text-white`}
                  >
                    보기
                  </Button>
                </td>
                <td>
                  <div className="card-toolbar">
                    <Dropdown className="dropdown-inline" alignRight>
                      <Dropdown.Toggle
                        className="btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                        variant="transparent"
                        id="dropdown-toggle-top"
                        as={DropdownCustomToggler}
                      >
                        <i className="ki ki-bold-more-hor" />
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                        <ul className="navi">
                          <li className="navi-item" onClick={toggleShow}>
                            수정
                          </li>
                          <li className="navi-item">삭제</li>
                          <li className="navi-item">사용중지</li>
                        </ul>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* end::Table */}
      </div>
      <div className="row">
        <div className="d-flex flex-center w-100">
          <Pagination>
            <Pagination.Prev />

            <Pagination.Item>{1}</Pagination.Item>
            <Pagination.Item>{2}</Pagination.Item>
            <Pagination.Item active>{3}</Pagination.Item>
            <Pagination.Item disabled>{4}</Pagination.Item>
            <Pagination.Item>{5}</Pagination.Item>

            <Pagination.Next />
          </Pagination>
        </div>
      </div>
    </div>
  );
}
export default PageId57;
